import { LinkButton } from '@yes.technology/react-toolkit'
import { Optional, Record as RRecord, Unknown } from 'runtypes'
import { StyleMap } from 'site/Renderer/hooks/useStyleMap'
import { PublicButtonPropsWithType } from 'shared/utils'

export type ActionButtonProps = {
  props: (
    | React.ComponentProps<typeof LinkButton>
    | PublicButtonPropsWithType
  ) & {
    styleMap?: StyleMap
  }
}

export const ActionButtonTypeGuard = RRecord({
  styleMap: Optional(Unknown)
})
